/**
 * Company nickname is the first hostname label, matching public API Origin parsing:
 * oficina.agendepro.com → oficina
 */
export function getCompanyNicknameFromHost(
  hostname: string = typeof window !== "undefined" ? window.location.hostname : ""
): string | null {
  const host = hostname.replace(/^www\./i, "").toLowerCase();
  if (!host || host === "localhost" || host === "127.0.0.1") {
    return null;
  }

  const parts = host.split(".");
  if (parts.length < 2) {
    return null;
  }

  return parts[0] || null;
}
